import { useCallback, useEffect, useState } from "react";
import { listBonuses } from "../../api/bonuses";
import { listBranches, listUsers } from "../../api/directory";
import { listBoxes } from "../../api/accounting";

const EMPTY = { user_id: "", branch_id: "", status: "", month: "", year: "", from_date: "", to_date: "",
  confirmation_status: "" };

// كل بيانات صفحة المكافآت في مكان واحد: الفلاتر + القوائم المرجعية (موظفون · فروع · صناديق).
export const useBonuses = () => {
  const [filters, setFilters] = useState(EMPTY);
  const [rows, setRows] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [branches, setBranches] = useState([]);
  const [boxes, setBoxes] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
    const data = await listBonuses(params);
    setRows(data.items || []);
    setLoading(false);
  }, [filters]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    listUsers(null, "active").then(setEmployees).catch(() => setEmployees([]));
    listBranches().then(setBranches).catch(() => setBranches([]));
    listBoxes().then(setBoxes).catch(() => setBoxes([]));
  }, []);

  return { filters, setFilters, rows, employees, branches, boxes, loading, reload: load };
};
